define('lib/analytics/combineBlocks',[], function () {
  // combines an array of blocks and returns a single obj
  return function combineBlocks(blocks) {
    var blocksArr = [];
    var combined = {};

    if (typeof blocks === 'undefined') {
      return {};
    }

    if (Array.isArray(blocks)) {
      blocksArr = blocks;
    } else {
      blocksArr.push(blocks);
    }

    blocksArr.map(function (obj) {
      return Object.keys(obj).forEach(function (key) {
        combined[key] = obj[key];
      });
    });

    return combined;
  };
});

